import { NotFoundPageComponent } from './not-found-page.component';

export const NOT_FOUND_ROUTES = [
  {
    path: '',
    component: NotFoundPageComponent
  }
];
